import { useState } from "react";
import StepAddSource from "@components/contributeCase/addSources/StepAddSources";
import StepResolution from "@components/contributeCase/addSources/StepResolution";
import StepDetails from "@components/contributeCase/addSources/StepDetails";
import StepThankyou from "@components/contributeCase/addSources/StepThankyou";
export default function AddSource({
  sourceSteps,
  setSourceSteps,
  outsetaUserId,
  slug,
}) {
  const [sourceUrl, setSourceUrl] = useState("");
  return (
    <>
      {sourceSteps === "addSource" && (
        <StepAddSource
          sourceUrl={sourceUrl}
          setSourceUrl={setSourceUrl}
          setSteps={setSourceSteps}
        />
      )}
      {sourceSteps === "resolution" && (
        <StepResolution
          setSteps={setSourceSteps}
          outsetaUserId={outsetaUserId}
        />
      )}
      {sourceSteps === "details" && (
        <StepDetails
          setSteps={setSourceSteps}
          sourceUrl={sourceUrl}
          setSourceUrl={setSourceUrl}
          outsetaUserId={outsetaUserId}
          slug={slug}
        />
      )}
      {sourceSteps === "thankyou" && <StepThankyou setSteps={setSourceSteps} />}
    </>
  );
}
